import { useSelector } from 'react-redux';

const usePermissions = () => {
	const userAccountTypeID = useSelector((state) => state.login?.user?.userAccountTypeID);

	return {
		hasEditPermissions: [1, 2, 3, 4].includes(userAccountTypeID),
		userAccountTypeID
	};
};

export default usePermissions;
